export default __webpack_public_path__ + "static/media/incr_SU.7320aa0e.PNG";